(function(){
     'use strict';

     angular
        .module('app')
        .factory('LocalizadorService', LocalizadorService);

    LocalizadorService.$inject = ['$http','ActivosService'];

    function LocalizadorService($http,ActivosService){


        var service= {
           getTiendas:getTiendas,
           getActivo:getActivo
        };

        return service;
        function getTiendas(a,b,c)
        {
            return ActivosService.FiltrosActivos(a,b,c,true).then((data)=>{
                return data;
            })
        }

        function getActivo(referencia_catastral)
        {
            return ActivosService.getActivo(referencia_catastral).then((data)=>{
                return data;
            })
        }


    }
})();